import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/cloud.svg'


const _withScopeId = n => (_pushScopeId("data-v-25ac8e03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file_image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "squareElement d-flex justify-content-center align-items-center pointer" }, " INSERIRE LOGO ", -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.fileModeIcon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "position-relative",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectFile()))
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
            style: {"cursor":"pointer"},
            type: "text",
            readonly: ""
          }, null, 512), [
            [_vModelText, _ctx.fileName]
          ]),
          _hoisted_2
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectFile())),
          class: _normalizeClass({whiteBg : _ctx.whiteBg})
        }, _hoisted_4, 2)),
    _createElementVNode("input", {
      hidden: "true",
      ref: "input",
      type: "file",
      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
      multiple: "false"
    }, null, 544)
  ]))
}